import { gql, TypedDocumentNode } from '@apollo/client';

import {
  TaskTemplate,
  TaskTemplateCreateInput,
  TaskTemplatesConnection,
  TaskTemplatesConnectionInput,
} from '@atom/types/taskTemplate';

export const BASE_TASK_TEMPLATE = gql`
  fragment BaseTaskTemplate on TaskTemplate {
    id
    name
    rootSchemaName
    rootSchemaId
    applicable
    locationsEnabled
    requireAtLeastOneLocation
    multiAssetsEnabled
    allowedMultiAssetSchemaIds
    allowedMultiAssetSchemas {
      id
      name
      markerId
      colorId
      ancestors
    }
    requireAtLeastOneMultiAsset
    requiredMultiAssetSchemaIds
    userIds
    users {
      id
      firstName
      lastName
      email
      photoUrl
    }
    userGroups {
      userGroupId
      name
      colorId
      quantity
      userCount
      workTime
      budget {
        budgetId
        rate
        restored
        reopenedWorkOrderIds
      }
    }
  }
`;

export const GET_TASK_TEMPLATES: TypedDocumentNode<
  { taskTemplates: TaskTemplatesConnection },
  { input: TaskTemplatesConnectionInput }
> = gql`
  query taskTemplates($input: TaskTemplatesConnectionInput!) {
    taskTemplates(input: $input) {
      totalCount
      taskTemplates {
        ...BaseTaskTemplate
      }
    }
  }
  ${BASE_TASK_TEMPLATE}
`;

export const TASK_TEMPLATE_CREATE: TypedDocumentNode<
  { taskTemplateCreate: TaskTemplate },
  { input: TaskTemplateCreateInput }
> = gql`
  mutation taskTemplateCreate($input: TaskTemplateCreateInput!) {
    taskTemplateCreate(input: $input) {
      ...BaseTaskTemplate
    }
  }
  ${BASE_TASK_TEMPLATE}
`;

export const TASK_TEMPLATE_DELETE: TypedDocumentNode<
  { taskTemplateDelete: boolean },
  { id: string }
> = gql`
  mutation taskTemplateDelete($id: ID!) {
    taskTemplateDelete(id: $id)
  }
`;
